var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "#E3E4FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3307 24.6668C10.8724 24.6668 10.4802 24.5038 10.1541 24.1777C9.82795 23.8516 9.66462 23.4591 9.66406 23.0002V13.0002C9.66406 12.5418 9.8274 12.1496 10.1541 11.8235C10.4807 11.4974 10.873 11.3341 11.3307 11.3335H16.3307L17.9974 13.0002H24.6641C25.1224 13.0002 25.5149 13.1635 25.8416 13.4902C26.1682 13.8168 26.3313 14.2091 26.3307 14.6668H11.3307V23.0002L13.3307 16.3335H27.5807L25.4349 23.4793C25.3238 23.8404 25.1191 24.1288 24.8207 24.3443C24.5224 24.5599 24.1924 24.6674 23.8307 24.6668H11.3307Z",
    fill: "#2E34D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18V21.1667L21 22",
    stroke: "#E3E4FE",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsFrame2);
export default __webpack_public_path__ + "static/media/stats_frame_2.7009a4fba7201ff3270014c997ed837a.svg";
export { ForwardRef as ReactComponent };